import { useState } from 'react';
import { load, save } from '../components/commons/localStorage';
const validateAndCleanVisibleContent = (storedValue, visibleColumns) => {
    if (!storedValue || !visibleColumns) {
        return storedValue;
    }
    // Get all valid column IDs from visibleColumns
    const validColumnIds = Object.keys(visibleColumns);
    // If storedValue has visibleContent array, validate it
    if ((storedValue === null || storedValue === void 0 ? void 0 : storedValue.visibleContent) && Array.isArray(storedValue.visibleContent)) {
        // Remove invalid keys that don't exist in visibleColumns
        const validKeys = storedValue.visibleContent.filter(key => validColumnIds.includes(key));
        // Add missing keys that have editable: false
        const missingNonEditableKeys = validColumnIds.filter(columnId => { var _a; return !validKeys.includes(columnId) && ((_a = visibleColumns[columnId]) === null || _a === void 0 ? void 0 : _a.editable) === false; });
        return Object.assign(Object.assign({}, storedValue), { visibleContent: [...validKeys, ...missingNonEditableKeys] });
    }
    return storedValue;
};
export const useVisibleColumnsLocalStorage = (key, defaultValue, visibleColumns) => {
    const [value, setValue] = useState(() => {
        var _a;
        const loadedValue = (_a = load(key)) !== null && _a !== void 0 ? _a : defaultValue;
        // If key exists in localStorage and visibleColumns is provided, validate and clean up
        if (load(key) && visibleColumns) {
            const validatedValue = validateAndCleanVisibleContent(loadedValue, visibleColumns);
            // Save the cleaned up value back to localStorage
            if (JSON.stringify(validatedValue) !== JSON.stringify(loadedValue)) {
                save(key, validatedValue);
            }
            return validatedValue;
        }
        return loadedValue;
    });
    function handleValueChange(newValue) {
        setValue(newValue);
        save(key, newValue);
    }
    return [value, handleValueChange];
};
